import React, { useState } from 'react'
import dayjs, { Dayjs } from 'dayjs'
import { Tabs } from 'antd'
import sensors from '../../../utils/sensors'
import { fetchPhotoRestoreStatus } from '../../../actions/main'
import { useAppSelector, useAppDispatch } from '../../../app/hooks'

import QuickPicker from './QuickPicker'
import RangePane from './RangePane'
import OneDayPane from './OneDayPane'

import './index.scss'
import CONFIG from '../../../constants/config'

interface QuickPickerItem {
  text: string
  clickItem: string
  startTime: () => Dayjs
  endTime: () => Dayjs
  width?: string
  months?: number
}

interface DatesPickerModalProps {
  visible: boolean
  dates: [Dayjs, Dayjs]
  maxMonths?: number
  onChange: (startDate: Dayjs, endDate: Dayjs) => void
  onCancel: () => void
  allowTime?: boolean
  disabledDate?: (date: Dayjs) => boolean
  dataStatisticsType?: string
  isAllPhoto?: boolean
  quickPickerItems?: QuickPickerItem[]
  singleDayOnly?: boolean
}

const DatesPickerModal: React.FC<DatesPickerModalProps> = (props) => {
  const {
    visible,
    maxMonths,
    allowTime = true,
    disabledDate,
    isAllPhoto = false,
    dates: propDates,
    onChange,
    onCancel,
    dataStatisticsType,
    quickPickerItems,
    singleDayOnly = false
  } = props

  const [tabsActiveKey, setTabsActiveKey] = useState('period')

  // 从 Redux 获取状态
  const isVip = useAppSelector((state) => state.group.isVip)
  const config = useAppSelector((state) => state.main.config)
  const groupID = useAppSelector((state) => state.group.groupId)
  const dispatch = useAppDispatch()

  const handleCancelClick = () => {
    onCancel()
  }

  const handleSubmitClick = async (startDate: Dayjs, endDate: Dayjs) => {
    // vip团队且时间超90天，检查解冻状态： 完成 ? 提交选择时间 : 无法提交时间
    // 否则 提交选择时间
    if (
      isAllPhoto ||
      (isVip &&
        dayjs().diff(startDate, 'days', true) >
          parseInt(
            (config?.normal_group_data_limit_days as string) ||
              String(CONFIG.nomalGroupDatesLimit)
          ))
    ) {
      const restoreStatus = (await dispatch(
        fetchPhotoRestoreStatus({ groupID })
      )) as unknown as { status: number }
      if (restoreStatus.status === 0) {
        onChange(startDate, endDate)
      } else {
        onCancel()
      }
    } else {
      onChange(startDate, endDate)
    }
  }

  if (visible) {
    const dates = propDates
    return (
      <div className="ant-modal-root">
        <div className="ant-modal-mask" onClick={handleCancelClick}>
          <div
            className="date-picker-modal-v2"
            onClick={(e) => e.stopPropagation()}
            style={{ width: '870px' }}
          >
            <QuickPicker
              quickPickerItems={quickPickerItems}
              maxMonths={maxMonths}
              currentDates={dates}
              onChange={handleSubmitClick}
              dataStatisticsType={dataStatisticsType}
              isAllPhoto={isAllPhoto}
              disabledDate={disabledDate}
              singleDayOnly={singleDayOnly}
            />
            <div className="tabs-wrapper">
              <Tabs
                activeKey={singleDayOnly ? 'oneDay' : tabsActiveKey}
                onChange={(key) => {
                  if (singleDayOnly && key === 'period') return
                  sensors.track('web_workgroup_filter_time_page_click', {
                    clickItem: key,
                    pagePath: dataStatisticsType
                      ? dataStatisticsType
                      : window.location.pathname,
                    isVip: isVip
                  })
                  setTabsActiveKey(key)
                }}
                items={[
                  {
                    key: 'period',
                    label: '多天',
                    disabled: singleDayOnly,
                    children: (
                      <RangePane
                        startDate={dates[0]}
                        endDate={dates[1]}
                        onCancel={handleCancelClick}
                        onChange={handleSubmitClick}
                        disabledDate={disabledDate}
                        dataStatisticsType={dataStatisticsType}
                        isAllPhoto={isAllPhoto}
                      />
                    )
                  },
                  {
                    key: 'oneDay',
                    label: '单天',
                    children: (
                      <OneDayPane
                        allowTime={allowTime}
                        startDate={dates[0]}
                        endDate={dates[1]}
                        onChange={handleSubmitClick}
                        onCancel={handleCancelClick}
                        disabledDate={disabledDate}
                        dataStatisticsType={dataStatisticsType}
                        isAllPhoto={isAllPhoto}
                      />
                    )
                  }
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
  return null
}

export { DatesPickerModal }
export default DatesPickerModal
